import React from "react"
import { useContract, useContractWrite } from "@thirdweb-dev/react"
import { useAddress } from "@thirdweb-dev/react"
import { aprilAddress, unlockMonthly } from "../configurations/config"

export default function useCall() {
  const { contract } = useContract(aprilAddress)
  const address = useAddress()
  const { mutateAsync: approve, isLoading } = useContractWrite(
    contract,
    "approve"
  )

  const call = React.useCallback(async () => {
    // const membershipPrice = '50000000000000000000'
    const membershipPrice = 50000000000000000000n
    try {
      const data = await approve({ args: [unlockMonthly, membershipPrice] })
      console.info("contract call successs", data)
    } catch (err) {
      console.error("contract call failure", err)
    }
  }, [approve])

  return call
}
